import {take, call, put, select} from 'redux-saga/effects'

import {
  FETCH_PRESENTATION_REQUEST,
  FETCH_STATIONS_REQUEST,
  SENDING_GROUPS_REQUEST,
  FETCH_GROUPS_REQUEST,
  FETCH_GROUPS_SUCCESS,
  FETCH_GROUPS_FAILURE,
  SENDING_GROUP_CREATE,
  CREATE_GROUP_REQUEST,
  //CREATE_GROUP_SUCCESS,
  CREATE_GROUP_FAILURE,
  SENDING_GROUP_UPDATE,
  UPDATE_GROUP_REQUEST,
  //UPDATE_GROUP_SUCCESS,
  UPDATE_GROUP_FAILURE,
  SENDING_GROUP_DELETE,
  DELETE_GROUP_REQUEST,
  //DELETE_GROUP_SUCCESS,
  DELETE_GROUP_FAILURE,
  FETCH_ACCOUNTS_REQUEST
} from '../actions/constants'

import {UUID_NULL} from '../constants/defaultValues'
import group from '../api/group'
import {putNotify} from './utils'

const getTokenFromState = (state) => state.user.currentUser.token;
const getSystemIDFromState = (state) => state.system.currentSystem.ID;

function* fetchGroups({token, systemID}) {
  yield put({type: SENDING_GROUPS_REQUEST, sending: true})
  try {
    return yield call(group.fetchGroups, token, systemID)
  } catch (error) {
    yield put({type: FETCH_GROUPS_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_GROUPS_REQUEST, sending: false})
  }
}

export function* watchFetchGroups() {
  while (true) {
    yield take([FETCH_GROUPS_REQUEST, FETCH_STATIONS_REQUEST, FETCH_PRESENTATION_REQUEST, FETCH_ACCOUNTS_REQUEST])
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(fetchGroups, {token, systemID})
    const arr = yield call(putNotify, {response})
    const groups = Array.isArray(arr)
      ? arr
      : []
    const roots = groups.filter((group) => {
      return group.ParentID === UUID_NULL
    });
    const treeDatas = roots.map((item) => {
      return {
        ...item,
        Childs: getNodeChilds(groups, item)
      }
    })
    yield put({type: FETCH_GROUPS_SUCCESS, treeGroups: treeDatas, groups: groups});
  }
}

const getNodeChilds = (datas, root) => {
  return datas.filter((item) => {
    return item.ParentID === root.ID
  }).map((item) => {
    return {
      ...item,
      Childs: getNodeChilds(datas, item)
    }
  })
}

function* createGroup({token, systemID, newGroupState}) {
  yield put({type: SENDING_GROUP_CREATE, sending: true})
  try {
    return yield call(group.postGroup, token, systemID, newGroupState)
  } catch (error) {
    yield put({type: CREATE_GROUP_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_GROUP_CREATE, sending: false})
  }
}

export function* watchCreateGroupRequest() {
  while (true) {
    const {newGroupState} = yield take(CREATE_GROUP_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(createGroup, {token, systemID, newGroupState})
    const notify = `Thêm mới địa bàn [${newGroupState.Name}] thành công!`
    yield call(putNotify, {response, notify})
    yield put({type: FETCH_GROUPS_REQUEST});
  }
}

function* updateGroup({token, systemID, updateGroupState}) {
  yield put({type: SENDING_GROUP_UPDATE, sending: true})
  try {
    return yield call(group.updateGroup, token, systemID, updateGroupState)
  } catch (error) {
    yield put({type: UPDATE_GROUP_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_GROUP_UPDATE, sending: false})
  }
}

export function* watchUpdateGroupRequest() {
  while (true) {
    const {updateGroupState} = yield take(UPDATE_GROUP_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(updateGroup, {token, systemID, updateGroupState})
    const notify = `Cập nhật địa bàn [${updateGroupState.Name}] thành công!`
    yield call(putNotify, {response, notify})
    yield put({type: FETCH_GROUPS_REQUEST});
  }
}

function* deleteGroup({token, systemID, deleteGroupState}) {
  yield put({type: SENDING_GROUP_DELETE, sending: true})
  try {
    return yield call(group.deleteGroup, token, systemID, deleteGroupState)
  } catch (error) {
    yield put({type: DELETE_GROUP_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_GROUP_DELETE, sending: false})
  }
}

export function* watchDeleteGroupRequest() {
  while (true) {
    const {deleteGroupState} = yield take(DELETE_GROUP_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(deleteGroup, {token, systemID, deleteGroupState})
    const notify = `Xoá địa bàn [${deleteGroupState.Name}] thành công!`
    yield call(putNotify, {response, notify})
    yield put({type: FETCH_GROUPS_REQUEST});
  }
}



// WEBPACK FOOTER //
// ./src/sagas/group.js